export const apiName: string = 'orgaos';
export const orgaosRoute: string = 'orgaos';
export const orgaosStorage: string = 'orgaos';
export const orgaosModuleName: any = {plural: 'Órgãos', single: 'Órgão'};

export const orgaosQuery: any = {
  "where":{
    "ativo":true,
    "razaoSocial":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"razaoSocial"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/shared/data.service.ts
 **/